// extracted by mini-css-extract-plugin
module.exports = {"icon":"RejectedTombstoneContainer-icon-54e1c3e4566b5e446cbfa10292753be9"};